module.exports = function(h, row) {
    let amount = row.amount.replace(/(\.[0-9]*?)0+$/, '$1');
    return amount.replace(/\.$/, '') + ' %';
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/tax/amount.jsx